import API from '@/services/api';
import ApiService from '@/utils/api.util';
import { API_CONSTANTS } from "@/constants/api.constant";
import router from '@/router/index';
import { useConfigStore } from "@/stores/config";
import { useNavigationStore } from "@/stores/navigation";
import ParentService from "./parent.service";
import { MessengerMode } from '@/types/Messenger';
import { NavigationTypeEnum } from '@/types/NavigationTypes';
import clone from 'lodash/clone';
// eslint-disable-next-line no-unused-vars
import { Views } from "@/types/ConfigTypes";
import ConversationService from "@/services/conversation.service";
import { consentRequired } from "@/utils/gdpr.util";
import SocketService from "@/services/socket.service";
let configStore;
let navStore;
let statusStore;
export default {
    getNavStore() {
        if (!navStore) {
            navStore = useNavigationStore();
        }
        return navStore;
    },
    getConfigStore() {
        if (!configStore) {
            configStore = useConfigStore();
        }
        return configStore;
    },
    getStatusStore() {
        if (!statusStore) {
            statusStore = useNavigationStore();
        }
        return statusStore;
    },
    async init(params) {
        // await delay(1000);
        // prepare query params but ignore filters
        return ApiService.request('post', API_CONSTANTS.API_URI_PREFIX + API.INIT, params).catch((error) => {
            throw new Error(error);
        });
    },
    sendOnlineHeartbeat() {
        const params = { online: true };
        return ApiService.request('post', API_CONSTANTS.API_URI_PREFIX + API.ONLINE, params).catch((error) => {
            throw new Error(error);
        });
    },
    async registerOnlinePoller() {
        setInterval(async () => {
            if (SocketService.isConnected()) {
                await this.sendOnlineHeartbeat();
            }
        }, 50000);
        // initial request
        setTimeout(async () => {
            if (SocketService.isConnected()) {
                await this.sendOnlineHeartbeat();
            }
        }, 2000);
    },
    test() {
        // prepare query params but ignore filters
        return ApiService.request('get', API_CONSTANTS.API_URI_PREFIX + API.TEST).catch((error) => {
            throw new Error(error);
        });
    },
    sendForm(method = 'get', endpoint, params = {}) {
        // prepare query params but ignore filters
        const url = !endpoint.includes('http://') && !endpoint.includes('https://') ? API_CONSTANTS.API_URI_PREFIX + endpoint : endpoint;
        return ApiService.request(method, url, params);
    },
    //nav
    push(name, params = {}, skipChangingView = false) {
        this._navigate(NavigationTypeEnum.PUSH, name, params, skipChangingView);
    },
    // override current location
    replace(name, params = {}, skipChangingView = false) {
        this._navigate(NavigationTypeEnum.REPLACE, name, params, skipChangingView);
    },
    // internal call only (use push or replace methods)
    _navigate(type, name, params = {}, skipChangingView = false) {
        if (!Object.keys(Views).includes(name))
            throw new Error(`invalid view name: "${name}"`);
        // if(this.getNavStore().getCurrentPath?.name === name) {
        //     return
        // throw new Error('view already active')
        // }
        // GDPR check
        if (consentRequired() && !ParentService.isGdprApproved()) {
            type = NavigationTypeEnum.PUSH;
            name = Views.GDPR;
            params = {};
        }
        else {
            // if desired view is CONVERSATION but { id } is not specified, follow logic below
            // 1) open last opened conversation, or in case no conversation has been opened yet since messenger load,
            // 2) load the last added one
            // 3) if there is no conversation present, create a new conversation
            if (name === Views.CONVERSATION) {
                const currentConversationId = ConversationService.getCurrentConversationId() || ConversationService.getLastConversationId();
                if (this.isConversationView() && params['id'] === currentConversationId) {
                    // same conversation already opened, exit
                    return;
                }
                else if (!params['id'] && !params['new']) {
                    params = { id: currentConversationId };
                }
            }
            else if (name === Views.PAGE && !params['id']) {
                params = { id: 'home ' };
            }
        }
        // this.$logger.debug('navigate '+type+' to: ', name, params)
        if (type === NavigationTypeEnum.PUSH) {
            this.getNavStore().push(name, params);
            if (!skipChangingView)
                router.push({ name: name, params: params }).then();
        }
        else if (type === NavigationTypeEnum.REPLACE) {
            this.getNavStore().replace(name, params);
            if (!skipChangingView)
                router.replace({ name: name, params: params }).then();
        }
        if (!skipChangingView)
            ParentService.changeView(name, params);
    },
    goBack() {
        const newPath = this.getNavStore().goBack();
        const obj = { name: newPath.name, params: newPath.params };
        router.push(obj);
        ParentService.changeView(obj.name, clone(obj.params));
    },
    refresh() {
        // need to implement
    },
    isPageView() {
        return this.getNavStore().getCurrentPath && this.getNavStore().getCurrentPath.name === Views.PAGE;
    },
    isGDPRView() {
        return this.getNavStore().getCurrentPath && this.getNavStore().getCurrentPath.name === Views.GDPR;
    },
    isConversationView() {
        return this.getNavStore().getCurrentPath && this.getNavStore().getCurrentPath.name === Views.CONVERSATION;
    },
    isHelpCenterView() {
        return this.getNavStore().getCurrentPath &&
            this.getNavStore().getCurrentPath.name === Views.HELPCENTER;
    },
    isArticleView() {
        return this.getNavStore().getCurrentPath &&
            this.getNavStore().getCurrentPath.name === Views.ARTICLE;
    },
    getCurrentView() {
        return this.getNavStore().getCurrentView;
    },
    getCurrentViewName() {
        return this.getNavStore().getCurrentPath ? this.getNavStore().getCurrentPath.name : '';
    },
    getChannels() {
        return this.getConfigStore().currentSettings?.channels;
    },
    getWhatsappPhoneNumber() {
        const channels = this.getChannels();
        // get the first whatsapp in settings.channels we can find
        for (let i = 0; i < channels.length; i++) {
            if (channels[i].type === 'WHATSAPP') {
                // remove -requested (awaiting server change)
                return channels[i].props?.phone.replace('-requested', '');
            }
        }
        return;
    },
    setToFloatingConversation(id) {
        ParentService.setMessengerMode(MessengerMode.FLOATING);
        this.push('FloatingConversation', { id: id });
        this.getConfigStore().setMessengerMode(MessengerMode.FLOATING);
    },
    isViewLoading() {
        return this.getNavStore().isLoading ? this.getNavStore().isLoading : false;
    },
    setAgentOnline(ev) {
        this.getStatusStore().setStatusOnline(ev);
    },
    updateAgents(ev) {
        this.getStatusStore().updateAgents(ev);
    }
};
